var _       = require('underscore');
var $       = require('jquery');
var Core    = require('../core/core.js');

/**
 * Creates an overlay tray large component item
 *
 * @class
 */

class TrayTabListComponentsItem extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'details': {
                    'thumb_url': ''
                }
            }
        };
    }

    constructor(options) {
        super(options);

        //add list component items automatically if view config is available
        if(options && options.viewConfig) {
            var self = this;

            this.template = `
            <div class="editor__tray__listcomponents__item clearfix">
                <div class="editor__tray__listcomponents__item__thumb">
                    <a class='editor__tray__listcomponents__item__link js-editor__tray__listcomponents__item__link'>
                        <div class='editor__tray__largecomponents__item__inner__img__loading'>
                            <img src="https://123d-circuits-assets.s3.amazonaws.com/thumbloading.png">
                            <div class="throbber">
                                <div class="throbber__bounce1"></div>
                                <div class="throbber__bounce2"></div>
                                <div class="throbber__bounce3"></div>
                            </div>
                        </div>
                        <img src="<%= external_url(details['thumb_url']) %>" onload="$(this).prev().remove();$(this).show();" onerror='$(this).attr("src", "https://123d-circuits-assets.s3.amazonaws.com/thumbnotfound.png");' style='display:none;'>
                    </a>
                </div>`;

            this.template += `
                <div class="editor__tray__listcomponents__item__extra">
                    <a class="btn btn--m btn--accent_none_accent js-editor__tray__listcomponents__item__link">
                        <div class='btn__txt'>Add</div>
                    </a>`;

                if(options.viewConfig.enableAssetDetails) {
                    this.template += `
                    <a class="btn btn--m btn--none_base_borders js-editor__tray__listcomponents__item__details" target="_blank">
                        <div class='btn__txt'>Details</div>
                    </a>`;
                }

                if(options.viewConfig.enable3dModelPreview) {
                    this.template += `
                    <a class="btn btn--m btn--none_base_borders" target="_blank">
                        <div class='btn__txt editor__tray__listcomponents__item__3dmodel__preview'>Preview</div>
                    </a>`;
                }

                this.template += `
                </div>`;

            // first do non right items
            options.viewConfig.columns.forEach(function(config) {
                if(config.location && options.viewConfig.enableLeftOverflow && config.location === 'left') return;
                self.template += `
                <div class="editor__tray__listcomponents__item__` + config.name.toLowerCase() + ((config.location && config.location === 'right') ? ' editor__tray__listcomponents__item__rightitem' : '') + `">`;
                    //add class if it is a link
                    if(config.isLink) {
                        self.template += `
                        <a class='editor__tray__listcomponents__item__link js-editor__tray__listcomponents__item__link'>`;
                    }

                    self.template += `
                        <%-` + "details['" + config.key + "']" + `%>`;

                    if(config.isLink) {//close tag
                        self.template += `
                        </a>`;
                    }

                self.template += `
                </div>`;
            });


            // then do left items inside wrapper
            if(options.viewConfig.enableLeftOverflow){
                self.template +="<div class='editor__tray__listcomponents__item__leftitems'>";
                options.viewConfig.columns.forEach(function(config) {
                    if(config.location && config.location === 'left'){
                        self.template += `
                        <div class=" editor__tray__listcomponents__item__leftitem`+((config.description)? '__description':'') + ` ">`;
                            //add class if it is a link
                            if(config.isLink) {
                                self.template += `
                                <a class='editor__tray__listcomponents__item__link js-editor__tray__listcomponents__item__link'>`;
                            }

                            self.template += `
                                <%-` + "details['" + config.key + "']" + `%>`;

                            if(config.isLink) {//close tag
                                self.template += `
                                </a>`;
                            }

                        self.template += `
                        </div>`;
                    }
                });
                self.template +="</div>";
            }

            this.template += `
            </div>`;
        }

        super.render();

        /**
         * Click item
         *
         * @fires TrayTabListComponentsItem#_itemClicked
         */

         $('.js-editor__tray__listcomponents__item__link', this.$el).on('click', this._itemClicked);
         $('.js-editor__tray__listcomponents__item__details', this.$el).on('click', this._detailsClicked);
         $('.editor__tray__listcomponents__item__3dmodel__preview', this.$el).on('click', this._preview3dModelClicked);
    }

    /**
     * @event TrayTabListComponentsItem#Cioui:TrayTabItem:clicked
     * @property {String}Cioui:TrayTabItem:clicked
     * @returns {Object} e - click event
     */

    _itemClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabItem:clicked', e);
    }

    _detailsClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabItem:detailsClicked', e);
    }

    _preview3dModelClicked(e) {
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabItem:Preview3dModelClicked', e);
    }

}
module.exports = TrayTabListComponentsItem;